import {Editor} from '@tiptap/react';
import React from 'react';
import {useSelector} from 'react-redux';
import {ChainedCommands} from '@tiptap/core';
import TextEditorButton from '../../../../../incase-domain/components/textEditor/TextEditorButton';
import TextEditorButtonWrapper from '../../../../../incase-domain/components/textEditor/TextEditorButtonWrapper';
import {editorModeSelector} from '../../../../../store/selectors/tiptapEditor.selectors';
import {EditorModeEnum} from '../../../../../store/actions/types/tiptapEditor.types';

interface FormattingToolbarProps {
    editor: Editor;
}

function FormattingToolbar({editor}: FormattingToolbarProps): JSX.Element {
    const editorMode = useSelector(editorModeSelector);

    const applyCommand = (fn: (chain: ChainedCommands) => ChainedCommands): void => {
        if (editorMode === EditorModeEnum.SELECT) {
            fn(editor.chain().selectAll()).run();
        } else {
            fn(editor.chain().focus()).run();
        }
    };

    return (
        <div style={{display: 'flex', gap: '1rem'}}>
            <div style={{display: 'flex', flexDirection: 'row', gap: '0.2rem'}}>
                <TextEditorButton
                    icon="ph:text-bolder-bold"
                    onClick={() => applyCommand((c) => c.toggleBold())}
                    isActive={editor.isActive('bold')}
                />
                <TextEditorButton
                    icon="ph:text-italic"
                    onClick={() => applyCommand((c) => c.toggleItalic())}
                    isActive={editor.isActive('italic')}
                />
                <TextEditorButton
                    icon="ph:text-underline"
                    onClick={() => applyCommand((c) => c.toggleUnderline())}
                    isActive={editor.isActive('underline')}
                />
            </div>
            <TextEditorButtonWrapper>
                <TextEditorButton
                    onClick={() => applyCommand((c) => c.setTextAlign('left'))}
                    isActive={editor.isActive({textAlign: 'left'})}
                    icon="ph:text-align-left"
                />
                <TextEditorButton
                    onClick={() => applyCommand((c) => c.setTextAlign('center'))}
                    isActive={editor.isActive({textAlign: 'center'})}
                    icon="ph:text-align-center"
                />
                <TextEditorButton
                    onClick={() => applyCommand((c) => c.setTextAlign('right'))}
                    isActive={editor.isActive({textAlign: 'right'})}
                    icon="ph:text-align-right"
                />
                <TextEditorButton
                    onClick={() => applyCommand((c) => c.setTextAlign('justify'))}
                    isActive={editor.isActive({textAlign: 'justify'})}
                    icon="ph:text-align-justify"
                />
            </TextEditorButtonWrapper>
        </div>
    );
}

export default FormattingToolbar;
